'use client';
import dynamic from 'next/dynamic';

import { LandingPageHero } from '@/components/home/landing-page-hero';
import {
  DARK_BACKGROUND_COLOR,
  PRIMARY_BACKGROUND_COLOR,
  WAVE_COLORS_3,
} from '@/constants/colors';

const DynamicNewWavyBackground = dynamic(
  () => import('@mcdougald/ui/src').then((mod) => mod.AdjustableWavyBackground),
  {
    ssr: false,
  },
);

export const Backdrop = () => {
  return (
    <DynamicNewWavyBackground
      // colors={['#eab308', '#facc15', '#f59e0b', '#fde68a', '#fef3c7']}
      backgroundFill={DARK_BACKGROUND_COLOR}
      // className="absolute top-0 left-0 w-full h-full"
      // containerClassName="bg-wavy-container w-full h-full"
      blur={2}
      canvasClassName="absolute h-[calc(15vh)] w-[calc(100vw)] blur-[3px]"
      className="backdrop absolute mx-0 h-full w-full"
      colors={WAVE_COLORS_3}
      containerClassName={`z-[-1] absolute left-0 transform-gpu w-full h-[calc(15vh)] !bg-${PRIMARY_BACKGROUND_COLOR}`}
      speed={7}
      waveAmplitude={0.7}
      waveOpacity={0.2}
      wavePinchEnd={0.6}
      wavePinchMiddle={0.064}
      waveWidth={1}
    />
  );
};

export const LandingBackdrop = () => {
  return (
    <DynamicNewWavyBackground
      // colors={['#eab308', '#facc15', '#f59e0b', '#fde68a', '#fef3c7']}
      backgroundFill={DARK_BACKGROUND_COLOR}
      // className="absolute top-0 left-0 w-full h-full"
      // containerClassName="bg-wavy-container w-full h-full"
      blur={2}
      canvasClassName="canvas-class absolute h-[220px] w-[calc(100vw)] blur-[0px]"
      className="landing-backdrop backdrop absolute mx-0 h-full w-full"
      colors={WAVE_COLORS_3}
      containerClassName={`container-class z-[-1] absolute left-0 transform-gpu w-full h-[220px] bg-[#${DARK_BACKGROUND_COLOR}]`}
      speed={10}
      waveCount={5}
      waveAmplitude={0.2}
      waveOpacity={0.2}
      wavePinchEnd={0.85}
      wavePinchMiddle={0.064}
      waveWidth={4}
    />
  );
};

/**
 * Todo: Fix HERO
 */
const LandingPageHeader = () => {
  return (
    <div className="relative min-h-[40vh] flex w-full overflow-hidden">
      <LandingBackdrop />
      <LandingPageHero />
    </div>
  );
};

export default LandingPageHeader;
